import { useEffect, useState } from "react";
import { useQuery } from "react-query";

import { userListFilterIProps } from "~/entity/Users/model/schema";

import { useUsers } from "./useUsers";

export const useGetUserList = (params: userListFilterIProps) => {
  const [userList, setUserList] = useState(null);
  const { getUserList } = useUsers();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [
      "getUserList",
      params.page,
      params.count,
      params.orderDirection,
      params.orderBy,
      params.searchText,
      params.id,
      params.fullName,
      params.login,
      params.position,
      params.email,
      params.phone,
      params.dealerIds,
      params.roleNames,
      params.permissionIds,
      params.subdivisionIds,
      params.status,
      params.statuses,
    ],
    queryFn: () => getUserList(params),
    refetchOnWindowFocus: false,
    enabled: !!params,
  });

  useEffect(() => {
    if (data?.status >= 200 && data?.status < 300 && !isLoading && !isError) {
      setUserList(data?.data);
    }
  }, [data, isLoading, isError]);

  return { data: userList, isLoading, isError, refetch };
};
